<p class="text-sm text-center">
  Please call us at <span class="font-semibold">{{appStore.location().phone | formatPhone}}</span> to let us know which tire you would like to order
</p>

@if (settings.get('quote_disclaimer').value) {
  <p class="text-sm text-center">{{ settings.get('quote_disclaimer').value }}</p>
}
